import { GlobalFormats } from '../../classess/main/globalFormats';
import { getLanguageObj, settings } from '../../helpers/main';

const currentMethod = 'AccessDenied';

const { icons, messages } = settings;

export default function AccessDenied({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    return (
        <div className='text-center py-5'>
            <i className={`${icons?.fasFa?.lock} fa-3x text-muted mb-3`}></i>
            <h3 className='text-muted'>{messages?.accessDenied?.[languageObj?.id]}</h3>
        </div>
    );
}